import type { ICardTabPanelModule } from '../types';

/**
 * Modul für Card-Tab-Panel-Funktionalität
 * Berechnet, wie viele Card-Tabs in ein Panel passen
 */
const CardTabPanelModule: ICardTabPanelModule = {
    /**
     * Zählt, wie viele Card-Tabs in ein Panel passen
     * @param panelId - Die ID des Panels
     * @returns Anzahl der Tabs, die passen
     */
    countCardTabsFitInPanel(panelId: string): number {
        const panel = document.getElementById(panelId);
        if (!panel) {
            console.warn(`Panel with id "${panelId}" not found`);
            return 0;
        }

        // Get all card tabs within the panel
        const cardTabs = panel.querySelectorAll<HTMLElement>('.card-tab:not(.more-button)');
        if (cardTabs.length === 0) {
            return 0;
        }

        // Get the computed style to read padding and gap
        const panelStyles = window.getComputedStyle(panel);
        const paddingLeft = parseFloat(panelStyles.paddingLeft) || 0;
        const gap = parseFloat(panelStyles.gap) || 0;

        // Get the available width of the panel
        const panelWidth = panel.getBoundingClientRect().width;

        // Calculate available width for tabs (subtract padding)
        const availableWidth = panelWidth - paddingLeft;

        let totalWidth = 0;
        let count = 0;

        // Iterate through tabs and count how many fit
        for (let i = 0; i < cardTabs.length; i++) {
            const tabWidth = cardTabs[i].offsetWidth;

            // Add gap before each tab except the first one
            const gapWidth = (count > 0) ? gap : 0;

            // Check if adding this tab (plus gap) would exceed available width
            if (totalWidth + gapWidth + tabWidth <= availableWidth) {
                totalWidth += gapWidth + tabWidth;
                count++;
            } else {
                // No more tabs fit
                break;
            }
        }

        return count;
    }
};

export default CardTabPanelModule;
